"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["startFrom", "endAt"],
    _excluded2 = ["loop"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Audio = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var get_environment_1 = require("../get-environment");

var loop_1 = require("../loop");

var Sequence_1 = require("../Sequence");

var use_video_config_1 = require("../use-video-config");

var validate_media_props_1 = require("../validate-media-props");

var validate_start_from_props_1 = require("../validate-start-from-props");

var duration_state_1 = require("../video/duration-state");

var AudioForDevelopment_1 = require("./AudioForDevelopment");

var AudioForRendering_1 = require("./AudioForRendering");

var shared_audio_tags_1 = require("./shared-audio-tags");

var AudioRefForwardingFunction = function AudioRefForwardingFunction(props, ref) {
  var audioContext = (0, react_1.useContext)(shared_audio_tags_1.SharedAudioContext);

  var startFrom = props.startFrom,
      endAt = props.endAt,
      otherProps = _objectWithoutProperties(props, _excluded);

  var loop = props.loop,
      propsOtherThanLoop = _objectWithoutProperties(props, _excluded2);

  var _ref = (0, use_video_config_1.useVideoConfig)(),
      fps = _ref.fps;

  var _ref2 = (0, react_1.useContext)(duration_state_1.DurationsContext),
      durations = _ref2.durations,
      setDurations = _ref2.setDurations;

  var onError = (0, react_1.useCallback)(function (e) {
    console.log(e.currentTarget.error);
    throw new Error("Could not play audio with src ".concat(otherProps.src, ": ").concat(e.currentTarget.error, ". See https://remotion.dev/docs/media-playback-error for help."));
  }, [otherProps.src]);
  var onDuration = (0, react_1.useCallback)(function (src, durationInSeconds) {
    setDurations({
      type: 'got-duration',
      durationInSeconds: durationInSeconds,
      src: src
    });
  }, [setDurations]);

  if (loop && props.src && durations[props.src] !== undefined) {
    var duration = Math.floor(durations[props.src] * fps);
    return (0, jsx_runtime_1.jsx)(loop_1.Loop, {
      layout: "none",
      durationInFrames: duration,
      children: (0, jsx_runtime_1.jsx)(exports.Audio, _objectSpread(_objectSpread({}, propsOtherThanLoop), {}, {
        ref: ref
      }))
    });
  }

  if (typeof startFrom !== 'undefined' || typeof endAt !== 'undefined') {
    (0, validate_start_from_props_1.validateStartFromProps)(startFrom, endAt);
    var startFromFrameNo = startFrom !== null && startFrom !== void 0 ? startFrom : 0;
    var endAtFrameNo = endAt !== null && endAt !== void 0 ? endAt : Infinity;
    return (0, jsx_runtime_1.jsx)(Sequence_1.Sequence, {
      layout: "none",
      from: 0 - startFromFrameNo,
      showInTimeline: false,
      durationInFrames: endAtFrameNo,
      children: (0, jsx_runtime_1.jsx)(exports.Audio, _objectSpread(_objectSpread({}, otherProps), {}, {
        ref: ref
      }))
    });
  }

  (0, validate_media_props_1.validateMediaProps)(props, 'Audio');

  if ((0, get_environment_1.getRemotionEnvironment)() === 'rendering') {
    return (0, jsx_runtime_1.jsx)(AudioForRendering_1.AudioForRendering, _objectSpread(_objectSpread({
      onDuration: onDuration
    }, props), {}, {
      ref: ref,
      onError: onError
    }));
  }

  return (0, jsx_runtime_1.jsx)(AudioForDevelopment_1.AudioForDevelopment, _objectSpread(_objectSpread({
    shouldPreMountAudioTags: audioContext !== null && audioContext.numberOfAudioTags > 0
  }, props), {}, {
    ref: ref,
    onError: onError,
    onDuration: onDuration
  }));
};

exports.Audio = (0, react_1.forwardRef)(AudioRefForwardingFunction);